import React, { Component } from "react"
import MorosoftPortfolio from "../Portfolios/index"

class OurPortfolioSection extends Component {
  render() {
    return (
      <section id="portfolio-section">
        <div className="container">
          <div className="row">
            <div className="col-12 about-pb">
              <div className="section-header">
                <h2 className="section-head-title m-0">Our Portfolio</h2>
              </div>
              <MorosoftPortfolio />
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default OurPortfolioSection
